module.exports = __webpack_public_path__ + "static/drawing-febf9ac75032eafc7bf46acb6ede613b.png";